export const Constants = {
  TAG_NAME: 'pop-holdings-table-component',
  NOT_APPLICABLE: 'N/A',
  NO_DATA_MESSAGE: 'No data available',
  EN_US: 'en-US',
  CURRENCY: 'currency',
  USD: 'USD',
  EXCEPT_ZERO: 'exceptZero',
  MINIMUM_ROWS_FOR_FIXED_HEIGHT: 11,
  SORT_LABEL: 'sort',
  ASCENDING_LABEL: 'ascending',
  DESCENDING_LABEL: 'descending',
  ASCENDING_ARIA_SORT_VALUE: 'ascending',
  DESCENDING_ARIA_SORT_VALUE: 'descending',
  SORT_EVENT: 'pop-holdings-sort',
  RIGHT_ALIGN: 'right-align',
  SORTED: 'sorted',
} as const;
